// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root[data-v-10bd00df]{display:flex;flex-direction:column;height:100vh;max-height:100vh;max-width:100vw;overflow:hidden}.header[data-v-10bd00df]{min-height:54px}.header[data-v-10bd00df],.logo-top[data-v-10bd00df]{-webkit-user-select:none;-moz-user-select:none;user-select:none}.logo-top[data-v-10bd00df]{pointer-events:none}.main[data-v-10bd00df]{flex:1;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
